import React from 'react';
import { Hidden } from '@material-ui/core';
import { useHistory, useLocation } from 'react-router';
import Banner from '@cpg-its/ads.containers.banner';
import { PageHeader } from '../../../../global/components/layout/page-header';
import { ContentSpacer } from '../../../../global/components/layout/generic-content-spacer';
import { SideBarContent } from '../../../../global/components/layout/sidebar-content';
import { GpsType } from '../../../../global/components/layout/layout-models';
import { GuidedProcessSupportBlock } from '../../../../global/components/guided-process-support-block';
import { WysiwygWithReactLink } from '../../../../global/components/wysiwyg-with-react-link';
import { PageContainer } from '../../../../global/components/layout/page-container';
import { MainContent } from '../../../../global/components/layout/main-content-container';
import { DividerSection } from '../../../../global/components/layout/divider-section';
import { useGpsType } from '../../../../global/hooks/useGpsType';
import { ButtonWrapper } from '../../../../global/components/layout/button-wrapper';
import { buttonStyles } from '../../../../global/constants/theme/styles/components/buttonstyles';
import { useBasePath } from '../../../../global/hooks/useBasePath';
import { ArcRoutes } from '../../constants/routes';

interface Props {
	model: {
		title: string;
		description: string;
		nextStep: string;
		successMessage: string;
		gps: GpsType;
		mapHomeButtonText: string;
	}
}

function InstitutionAddAndRemoveConfirmation(props: Props) {

	const { model } = props;

	const gpsItem = useGpsType(model.gps);
	const buttonClass = buttonStyles();
	const mapHome = useBasePath(`${ArcRoutes.ArcRoot}`);
	const history = useHistory();
	const { state } = useLocation<any>();
	return (
		<PageContainer>
			<MainContent>
				<ContentSpacer>
					<Banner
						banner={{
							type: 'success',
							label: <WysiwygWithReactLink content={model.successMessage} />,
						}}
					/>
				</ContentSpacer>
				<PageHeader headerText={model.title} description={model.description?.replace('{date}', state?.date)?.replace('{institution}', state?.institution)} />
				<Hidden mdUp>
					<SideBarContent>
						<GuidedProcessSupportBlock title={gpsItem?.title} contents={gpsItem.contents} />
					</SideBarContent>
				</Hidden>
				<DividerSection removeDivider >
					<WysiwygWithReactLink content={model.nextStep} />
				</DividerSection>
				<ButtonWrapper flexEnd>
					<button className={buttonClass.primaryButton} type='button' onClick={() => history.push(mapHome)} >{model?.mapHomeButtonText}</button>
				</ButtonWrapper>
			</MainContent>
			<Hidden smDown>
				<SideBarContent>
					<GuidedProcessSupportBlock title={gpsItem?.title} contents={gpsItem.contents} />
				</SideBarContent>
			</Hidden>
		</PageContainer>
	);
}

export default InstitutionAddAndRemoveConfirmation;